import { Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import empty from '../../../../../../../../../assets/empty.png'
import { request_business, request_employees, request_process, request_update_process } from '../../../../../../requests'
import Banner from '../../Banner'
import { contentData } from './content'
import DisplayText from '../../../../../../../../../components_v1/Texts/DisplayText'
import BasicView from '../../../../../../../../../components_v1/Structure/Layouts/BasicView'
import { nodata } from '../../../../../../../../../texts/esp/general'
import EditModal from './modals/EditModal'
import { onGetErrorMessage } from '../../../../../../../../../shared/utility'
import History from '../../History/History'

const PhysicalPersons = ({ history, language, id, clientID }) => {

  const [loading, setLoading] = useState(false)
  const [sending, setSending] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)

  const [process, setProcess] = useState(null)
  const [employees, setEmployees] = useState([])
  const [edit_modal, setEditModal] = useState(false)

  const content = contentData[language]

  useEffect(() => {
    const initModule = async () => {
      try {
        setLoading(true)

        const _employees = await request_employees()
        setEmployees(_employees)

        const _accounting = await request_process(id, 'accounting', 'accounting')
        const _monthlyStatements = await request_process(id, 'monthlystatement', 'monthly_statement_record')
        const _clients = await request_process(clientID, 'client', 'client')
        const _business = await request_business(id)
        setProcess({ ..._monthlyStatements, ..._clients, ..._accounting, advisor: _business.advisor, advisor_id: _business.advisor_id })

        setLoading(false)
      } catch (e) {
        setError(onGetErrorMessage(error))
        console.log(error)
      }
      setLoading(false)
    }
    initModule()
  }, [])

  const onUpdateCompleted = async (data) => {
    try {
      setSending(true)
      await request_update_process(id, 'accounting', data)
      await request_update_process(id, 'monthlystatement', { responsible_id: data.fixed_responsible_id })
      await request_update_process(id, 'business', { advisor_id: data.advisor_id })
      const _accounting = await request_process(id, 'accounting', 'accounting')
      const _monthlyStatements = await request_process(id, 'monthlystatement', 'monthly_statement_record')
      const _clients = await request_process(clientID, 'client', 'client')
      const _business = await request_business(id)
      setProcess({ ..._monthlyStatements, ..._clients, ..._accounting, advisor: _business.advisor, advisor_id: _business.advisor_id })
      setSending(false)
      setSuccess(true)
      setEditModal(false)
    } catch (error) {
      setError(onGetErrorMessage(error))
      console.log(error)
    }

    setSending(false)
  }

  return (
    <BasicView
      history={history}
      title={content.title}
      loading={loading}
      error={error}
      onCloseError={() => setError(null)}
      success={success}
      onCloseSuccess={() => setSuccess(null)}
      setReturn
    >
      <div>
        <EditModal open={edit_modal} onClose={() => setEditModal(false)} init_data={process} employees={employees} onUpdateCompleted={onUpdateCompleted} />
        {process ?
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Banner content={content.banners.general} data={process} nodata={nodata} onEdit={() => setEditModal(true)} />
            </Grid>
            <Grid item xs={12}>
              <History type='physical_persons' content={content.banners.history} id={id} data={process} nodata={nodata} />
            </Grid>
          </Grid>
          :
          <div style={{ marginTop: 40 }}>
            <Grid container justify='center' alignItems='center' direction='column'>
              <Grid item>
                <img src={empty} alt='' width={180} />
              </Grid>
              <Grid item>
                <DisplayText>No se encontraron registros</DisplayText>
              </Grid>
            </Grid>
          </div>
        }
      </div>
    </BasicView>
  )
}

export default PhysicalPersons
